






































































































import { defineComponent, ref, useFetch, useContext } from '@nuxtjs/composition-api'
import axios from 'axios';
import { useConfig } from '~/composables';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';
import { getTagColor, getTags } from '~/utils/solepro/products';
import { proHighlightProductTrack, proHighlightButtonTrack } from '~/helpers/trackings/24orepro/home';
import { getAxiosConfigs } from '~/utils/solepro/functions';
import Spinner from '~/components/solepro/Spinner.vue';

export default defineComponent({
    components: {
        Spinner
    },
    setup() {
        const categories = ref([])
        const allCategories = ref([]);
        const categoryStore = useCategoryStore()
        const { config } = useConfig()
        const { app } = useContext();
        const isLoading = ref(false);
        useFetch(async () => {
            isLoading.value = true;
            const { data } = await axios.get('/sole-api/category/pro/categoryHighlightedProducts', {
                ...getAxiosConfigs(app, config)
            });

            categories.value = data;
            categoryStore.load();
            allCategories.value = categoryStore.rawCategories?.items[0].children
            categories.value.forEach((category, index) => {
                category.highlighted_products_details.forEach((product, pindex) => {
                    categories.value[index].highlighted_products_details[pindex].tags = getTags(allCategories.value, product)
                })
            })
            isLoading.value = false;
        })
        return {
            categories,
            allCategories,
            autoplay: 5000,
            autoSlideInterval: null,
            currentIndex: 0,
            storeCode: config.value.store_code,
            isLoading,
            IMAGE_STATIC_REPLACEMENT: app.$config.IMAGE_STATIC_REPLACEMENT,
            IMAGE_CDN_REPLACEMENT: app.$config.IMAGE_CDN_REPLACEMENT,
        }
    },
    mounted() {
        window.addEventListener("resize", () => {
            this.resetHighlights();
        });
        setTimeout(() => {
            if (window.innerWidth > 1024) {
                this.startAutoSlide();
                this.resetTimerAnimation();
            }
            this.setTablistOrientation();
            
        }, 3000)

    },
    destroyed() {
        window.removeEventListener('resize', this.resetHighlights);
    },
    methods: {
        trackButtonProduct() {
            proHighlightButtonTrack()
        },
        async trackProduct(val, link) {
            await proHighlightProductTrack(val);
            location.href = link
        },
        getColor(rgbaColor){
            return getTagColor(rgbaColor)
        },
        toggleHighlight(e) {
            e.preventDefault();
            e.stopPropagation();
            const index = e.target.getAttribute("data-index");
            const url = e.target.getAttribute("data-url");
            const tabID = e.target.getAttribute("aria-controls");
            const tab = this.$el.querySelector(`#${tabID}`);

            if (!index || !tabID || !tab) return;

            this.resetTriggersFocus();
            this.resetTabsFocus();
            this.selectTab(e.target, tab, index, url);
            this.currentIndex = parseInt(index);

            if (window.innerWidth > 1024) {
                this.resetAutoSlide();
                this.resetTimerAnimation();
            }
        },
        handleKeydown(e, index) {
            const isMobile = window.innerWidth <= 1024;

            switch (e.key) {
                case "ArrowDown":
                    if (isMobile) break;
                    e.preventDefault();
                    this.focusNextTrigger(index);
                    break;
                case "ArrowLeft":
                    if (!isMobile) break;
                    e.preventDefault();
                    this.focusPreviousTrigger(index);
                    break;
                case "ArrowUp":
                    if (isMobile) break;
                    e.preventDefault();
                    this.focusPreviousTrigger(index);
                    break;
                case "ArrowRight":
                    if (!isMobile) break;
                    e.preventDefault();
                    this.focusNextTrigger(index);
                    break;
                case "Space":
                    e.preventDefault();
                    this.toggleHighlight(e);
            }
        },
        focusNextTrigger(index) {
            const triggers = this.$el.querySelectorAll('.js-highlight-trigger') as unknown as [HTMLElement];
            const nextIndex = (index + 1) % triggers.length;
            triggers[nextIndex].focus();
        },
        focusPreviousTrigger(index) {
            const triggers = this.$el.querySelectorAll('.js-highlight-trigger') as unknown as [HTMLElement];
            const prevIndex = (index - 1 + triggers.length) % triggers.length;
            triggers[prevIndex].focus();
        },
        resetHighlights() {
            const triggers = this.$el.querySelectorAll('.js-highlight-trigger');
            const tabs = this.$el.querySelectorAll('.js-highlight-content')
            this.resetTriggersFocus();
            this.resetTabsFocus();
            this.selectTab(triggers[0], tabs[0], 0, triggers[0].getAttribute('data-url'));
            this.currentIndex = 0;

            if (window.innerWidth > 1024) {
                this.resetAutoSlide();
                this.resetTimerAnimation();
            } else {
                clearInterval(this.autoSlideInterval);
                (this.$el.querySelector(".js-highlight-timer") as HTMLElement).style.animation = "none";
            }

            this.setTablistOrientation();
        },
        resetTimerAnimation() {
            const timer = this.$el.querySelector(".js-highlight-timer") as HTMLElement;
            timer.style.animation = "none";
            void timer.offsetWidth;
            timer.style.animation = `progress ${this.autoplay}ms linear infinite`;
        },
        setTablistOrientation() {
            if (window.innerWidth > 1024) {
                this.$el.querySelector("ul[role='tablist']").setAttribute("aria-orientation", "vertical");
            } else {
                this.$el.querySelector("ul[role='tablist']").setAttribute("aria-orientation", "horizontal");
            }
        },
        resetTriggersFocus() {
            const triggers = this.$el.querySelectorAll('.js-highlight-trigger') as unknown as [HTMLElement];
            triggers.forEach((trigger) => {
                trigger.setAttribute("aria-selected", "false");
                trigger.setAttribute("tabindex", "-1");
                trigger.classList.remove("selected");
            });
        },
        resetTabsFocus() {
            const tabs = this.$el.querySelectorAll('.js-highlight-content');
            tabs.forEach((content) => {
                content.setAttribute("aria-hidden", "true");
                const focusableLinks = content.querySelectorAll("a[href]");

                focusableLinks.forEach((link) => {
                    link.setAttribute("tabindex", "-1");
                });
            });
        },
        selectTab(target, tab, index, url) {
            target.classList.add("selected");
            target.setAttribute("aria-selected", "true");
            target.setAttribute("tabindex", "0")

            tab.setAttribute("aria-hidden", "false");
            const focusableLinks = tab.querySelectorAll("a[href]");
            focusableLinks.forEach((link) => {
                link.setAttribute("tabindex", "0");
            });
            this.slideEffect(index);

            if (url) {
                this.$el.querySelector(".js-tabpanel-link").setAttribute("href", url);
            }
        },
        resetAutoSlide() { },
        slideEffect(index) {
            const area = this.$el.querySelector(".js-highlight-area") as HTMLElement;
            const areaWidth = area.offsetWidth;
            const translateX = areaWidth * index;
            area.style.transform = `translateX(-${translateX}px)`;
        },
        startAutoSlide() {
            const triggers = this.$el.querySelectorAll('.js-highlight-trigger') as unknown as [HTMLElement];
            let currentIndex = this.currentIndex || 0;
            this.autoSlideInterval = setInterval(() => {
                currentIndex = (currentIndex + 1) % triggers.length;
                triggers[currentIndex]?.click();
            }, this.autoplay);
        }
    }
})
